import { Component } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "recompose";
import { openWizard } from "src/modules/pairing/duck/actions";
import NavigationBar from "src/components/NavigationBar";
import MyAccountFlow from "src/flows/MyAccount";
import enableDebugSettings from "src/modules/debug/enableDebugSettings";
import { getIsDebugEnabled } from "src/duck/selectors";
import AvatarsFlow from "src/modules/avatar/AvatarsFlow";
import CommandsFlow from "src/modules/command/CommandsFlow";
import DebugSettings from "src/modules/debug/scenes/DebugSettings";
import LullabiesFlow from "src/modules/lullaby/LullabiesFlow";
import ListButton from "src/components/ListButton";
import PairedDevices from "src/scenes/PairedDevices";
import General from "src/scenes/General/General";
import environment, { getAppValue } from "src/utils/environment";
import { H4 } from "src/atoms/typography";
import ScrollBox from "src/atoms/ScrollBox";
import openExternal from "src/utils/openExternal";

import { ReactComponent as AddIcon } from "src/icons/add-circle-outlined.svg";
import { ReactComponent as AccountIcon } from "./icons/account-outlined.svg";
import { ReactComponent as CommandsIcon } from "./icons/command-24.svg";
import { ReactComponent as PairedDevicesIcon } from "./icons/devices.svg";
import { ReactComponent as PawIcon } from "./icons/paw-outlined.svg";
import { ReactComponent as StrollerIcon } from "./icons/stroller-outlined.svg";
import { ReactComponent as MusicIcon } from "./icons/music-outlined.svg";
import { ReactComponent as MoreIcon } from "./icons/more-circle.svg";
import { ReactComponent as FacebookIcon } from "./icons/facebook-f-outlined.svg";
import { ReactComponent as MailIcon } from "./icons/mail-outlined.svg";
import { ReactComponent as InfoIcon } from "./icons/info-outlined.svg";
import SceneAnimation from "src/components/SceneAnimation";
import { AnimatePresence } from "framer-motion";
import { colorMap } from "src/modules/colors";

const { app } = window.require("@electron/remote");

class Settings extends Component {
  constructor() {
    super();
    if (environment.isBrowser) this.buttonsGroup2.pop();
  }
  state = {
    OpenedFlow: null,
    flowDirection: "next"
  };

  debugMenuItem = {
    labelKey: "debugSettings",
    icon: InfoIcon,
    onClick: () => this.openFlow(DebugSettings),
    iconFill: colorMap.debug
  };

  buttonsGroup1 = [
    {
      labelKey: "account",
      icon: AccountIcon,
      onClick: () => this.openFlow(MyAccountFlow),
      iconFill: colorMap.account
    },
    {
      labelKey: getAppValue({
        barkio: "command.commands",
        bibino: "lullabies"
      }),
      icon: getAppValue({
        barkio: CommandsIcon,
        bibino: MusicIcon
      }),
      iconFill: colorMap.audioFiles,
      onClick: () => this.openFlow(getAppValue({ barkio: CommandsFlow, bibino: LullabiesFlow }))
    },
    {
      labelKey: "avatars",
      icon: getAppValue({ barkio: PawIcon, bibino: StrollerIcon }),
      onClick: () => this.openFlow(AvatarsFlow),
      iconFill: colorMap.avatars
    },
    {
      labelKey: "pairedDevices.heading",
      icon: PairedDevicesIcon,
      onClick: () => this.openFlow(PairedDevices),
      iconFill: colorMap.pairedDevices
    },
    {
      labelKey: "parentStation.settings.general.heading",
      icon: MoreIcon,
      onClick: () => this.openFlow(General),
      iconFill: colorMap.general
    }
  ];

  buttonsGroup2 = [
    {
      labelKey: "community.heading",
      icon: FacebookIcon,
      onClick: () => openExternal({ env: "FACEBOOK_GROUP" }),
      iconFill: colorMap.community
    },
    {
      labelKey: "purchase.help.contactUs.heading",
      icon: MailIcon,
      onClick: () => openExternal({ env: "EMAIL" }),
      iconFill: colorMap.contact
    },
    {
      labelKey: "settings.appVersion",
      icon: InfoIcon,
      additionalText: app?.getVersion?.(),
      renderAdditionalIcon: false,
      onParentClick: enableDebugSettings(),
      iconFill: colorMap.appVersion
    }
  ];

  openFlow = (Flow) => {
    this.setState({ flowDirection: "next" }, () => this.setState({ OpenedFlow: Flow }));
  };
  closeFlow = () => {
    this.setState({ flowDirection: "previous" }, () => this.setState({ OpenedFlow: null }));
  };

  render() {
    const { OpenedFlow, flowDirection } = this.state;
    const { t, onClose, enableDebug, openWizard } = this.props;
    const buttonsGroup1 = enableDebug ? [...this.buttonsGroup1, this.debugMenuItem] : this.buttonsGroup1;

    return (
      <AnimatePresence initial={false}>
        {OpenedFlow ? (
          <SceneAnimation key="flow" direction={flowDirection}>
            <OpenedFlow onClose={onClose} onBack={this.closeFlow} />
          </SceneAnimation>
        ) : (
          <SceneAnimation key="settings" direction={flowDirection}>
            <NavigationBar headingKey="settings" onClose={onClose} />
            <Box py="8px" height="100%">
              <ScrollBox height="calc(100% - 61px)" overflowX="hidden">
                <Box width="50%" pr="24px" mt="8px">
                  <ListButton
                    icon={AddIcon}
                    iconFill={colorMap.pairDevice}
                    ml="24px"
                    label={t("buttons.pairNewDevice")}
                    onClick={() => openWizard()}
                  />
                </Box>
                <H4 color="highEmphasis" ml="24px" mt="16px" mb="8px">
                  {t("parentStation.settings.general.heading")}
                </H4>
                <Flex flexWrap="wrap" mt="16px" mr="-24px" px="24px" bg="surfaceElevated1">
                  {buttonsGroup1.map((button) => (
                    <Box key={button.labelKey} width="50%" pr="24px" mb="16px">
                      <ListButton {...button} />
                    </Box>
                  ))}
                </Flex>
                <H4 color="highEmphasis" ml="24px" mt="16px" mb="8px">
                  {t("about.title")}
                </H4>
                <Flex flexWrap="wrap" mt="16px" mr="-24px" px="24px" bg="surfaceElevated1">
                  {this.buttonsGroup2.map((button) => {
                    const { onParentClick, ...rest } = button;
                    return (
                      <Box key={button.labelKey} onClick={onParentClick} width="50%" pr="24px" mb="16px">
                        <ListButton {...rest} />
                      </Box>
                    );
                  })}
                </Flex>
              </ScrollBox>
            </Box>
          </SceneAnimation>
        )}
      </AnimatePresence>
    );
  }
}

function mapStateToProps(state) {
  return {
    enableDebug: getIsDebugEnabled(state)
  };
}

const enhance = compose(
  withTranslation(),
  connect(mapStateToProps, {
    openWizard: () => openWizard({ initialStep: "manual-pairing" })
  })
);
export default enhance(Settings);
